// import { GENERATE_URL } from "./helpers/request.js";

import File from "./File";

export default {
  File,
};
